import { IBetLimits, TableConfigType } from '@pp/core';

import { Bets } from './bets';

const tableConfigMock: TableConfigType = {
  aamsSessionId: null,
  aamsTicket: null,
  payouts: [],
  bettingTime: 15000,
  betLimits: {
    [Bets.One]: { min: 0.1, max: 500 },
    [Bets.Two]: { min: 0.1, max: 250 },
    [Bets.Five]: { min: 0.1, max: 200 },
    [Bets.Eight]: { min: 0.1, max: 200 },
    [Bets.Ten]: { min: 0.1, max: 200 },
    [Bets.Fifteen]: { min: 0.1, max: 100 },
    [Bets.Twenty]: { min: 0.1, max: 100 },
    [Bets.Thirty]: { min: 0.1, max: 100 },
    [Bets.Forty]: { min: 0.1, max: 100 },
  },
  chipAmounts: [0.1, 0.5, 1.0, 5.0, 10.0, 25.0, 100.0, 500.0],
  chipColorCodes: ['#9D9A92', '#FF8E09', '#00A775', '#0093D1', '#EFAC00', '#D33939', '#800AC8', '#DE138E'],
  gameTypeId: Number('000000000000008'),
  gsAddress: 'https://gs14.pragmaticplaylive.net',
  hlsLocation: 'https://ios1.pragmaticplaylive.net/MOW13',
  isPrizeDropBetDataSendEnabled: true,
  isPromoBetDataSendEnabled: true,
  openTime: 0,
  openHours: null,
  operatorGameId: '1101',
  payoutBetMaxLimit: 500000,
  sessionLaunchTimePerTable: '16/03/2023 06:46:17 AM',
  tableBetLimit: {
    max: 1000,
    min: 0.1,
  },
  tableClosed: false,
  tableName: 'MEGA_WHEEL',
  tableType: 'Mega Wheel',
  videoLocation: 'wss://ws1.pragmaticplaylive.net/MOW13',
  wsAddress: 'wss://gs14.pragmaticplaylive.net/game',
  idleLimit: 0,
  defaultChipOrder: 1,
  gameStatsAddress: '',
  enableVideoStats: false,
  storeVideoQuality: false,
  retrieveVideoQuality: false,
  operatorTheme: 'default/sb1.1',
  broadcasterEnabled: false,
  chatVisibleByDefault: false,
  isInfiniteAutoPlayEnabled: false,
  hideLobby: false,
};

interface BetLimitData {
  minKey: string;
  maxKey: string;
}

const betLimitData: Record<number, BetLimitData> = {
  [Bets.One]: { minKey: 'one_bet_min', maxKey: 'one_bet_max' },
  [Bets.Two]: { minKey: 'two_bet_min', maxKey: 'two_bet_max' },
  [Bets.Five]: { minKey: 'five_bet_min', maxKey: 'five_bet_max' },
  [Bets.Eight]: { minKey: 'eight_bet_min', maxKey: 'eight_bet_max' },
  [Bets.Ten]: { minKey: 'ten_bet_min', maxKey: 'ten_bet_max' },
  [Bets.Fifteen]: { minKey: 'fifteen_bet_min', maxKey: 'fifteen_bet_max' },
  [Bets.Twenty]: { minKey: 'twenty_bet_min', maxKey: 'twenty_bet_max' },
  [Bets.Thirty]: { minKey: 'thirty_bet_min', maxKey: 'thirty_bet_max' },
  [Bets.Forty]: { minKey: 'fourty_bet_min', maxKey: 'fourty_bet_max' },
};

const parseBetLimits = (result: Record<string, any>): IBetLimits => {
  const betLimits: IBetLimits = {};

  for (const bet in Bets) {
    if (isNaN(Number(bet))) {
      continue; // Skip enum keys that are not numeric
    }

    const minKey = betLimitData[bet].minKey;
    const maxKey = betLimitData[bet].maxKey;

    betLimits[bet] = {
      min: Number.parseFloat(result[minKey]) || 0.1,
      max: Number.parseFloat(result[maxKey]) || 100, // Change the default max value if needed
    };
  }
  return betLimits;
};

export const tableConfigOptions = {
  tableConfigMock,
  parseBetLimits,
};
